import httpCustomer from "./httpServiceCustomer";

const apiEndpoint = "/salasP";

export function getSalas() {
    return httpCustomer.get(apiEndpoint);
}
